import { useT } from '../i18n/index.js';
import { useUiLang } from '../state/prefs.js';

/** "Due Tue, 3 Oct" in the UI language. */
export function useDueText() {
  const t = useT();
  const lang = useUiLang();
  return (due: string | null) =>
    due
      ? t.homework.due(
          new Date(`${due}T12:00:00Z`).toLocaleDateString(lang, {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
          }),
        )
      : t.homework.noDue;
}
